import React from "react";
import { useLocation, useParams } from "react-router-dom";

const ViewCertificate = () => {
  const location = useLocation();
  const { studentName, courseName, completionDate, instructorName } =
    location.state || {};

  return (
    <div>
      {studentName && courseName ? (
        <div>
          <h1>Certificate of Completion</h1>
          <p>This is to certify that {studentName}</p>
          <p>has successfully completed the course</p>
          <h2>{courseName}</h2>
          <p>on {completionDate}</p>
          <p>Instructor: {instructorName}</p>
        </div>
      ) : (
        <p>No certificate data available.</p>
      )}
    </div>
  );
};

export default ViewCertificate;
